import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import axios from "axios";
import { toast } from "react-toastify";
import WalletFloatingHeader from "./WalletFloatingHeader";
import WalletFastDeposit from "./WalletFastDeposit";
import WalletBalance from "./WalletBalance";
import WalletHelp from "./WalletHelp";
import WalletButtons from "./WalletButtons";
import { defaultTranslations } from "./defaultTranslations";

const Wallet = ({
  dateLocale,
  hideGamblingReferences,
  hideTransactions,
  hideDeposit,
  showFonixDeposit,
  translations,
  onError,
  currencySymbol,
  isScrolledDown,
  isExample
}) => {
  useEffect(() => {
    window.xtremepush("tag", "wallet_screen", JSON.stringify({
      AppName: process.env.REACT_APP_TITLE
    }));
  }, []);

  if (!translations) {
    translations = defaultTranslations;
  }

  const location = useLocation();
  const [isLoading, setLoading] = useState();
  const [wallet, setWallet] = useState();
  const [mobileNumberVerified, setMobileNumberVerified] = useState();
  const [myId, setMyId] = useState();
  const [activeButton, setActiveButton] = useState();
  const [addCardUrl, setCardUrl] = useState();
  const [addCardError, setCardError] = useState();
  const [transactionsUpdated, setTransactionsUpdated] = useState(false);
  let profileRes, walletRes, transactionsRes, depositLimitRes;

  const getWallet = async () => {
    setLoading(true);

    try {
      profileRes = await axios.get("/me?include=address,roles,permissions&server-time");
      setMobileNumberVerified(profileRes?.data?.data?.mobileNumberVerified);
      setMyId(profileRes?.data?.data?.id);
    } catch ({
      response
    }) {
      setLoading(false);
      onError(response);
    }

    try {
      walletRes = await axios.get(`/wallet`);
      setWallet(walletRes?.data?.data);
    } catch ({
      response
    }) {
      setLoading(false);
      onError(response);
    }
  };

  useEffect(() => {
    if (location?.search.includes("paymentStatus")) {
      const isSuccess = location?.search.includes("paymentStatus=AUTHORISED");

      if (isSuccess) {
        toast.success(translations.cardAdded);
      } else {
        toast.error(translations.errorAddingCard);
      }
    }
  }, []);

  const toggleActive = index => {
    if (index === activeButton) {
      setActiveButton(undefined);
    } else {
      setActiveButton(index);
    }
  };

  let isIframe = undefined;

  if (window.self !== window.top) {
    isIframe = true;
  } else {
    isIframe = false;
  }

  const getAddCardUrl = () => {
    axios.get(`/wallet/hosted/card/`).then(({
      data
    }) => {
      setCardUrl(data?.url);
    }).catch(error => {
      let message = "";

      if (error?.response?.data?.code === "balanceTooHigh") {
        message = translations.errorAddingCardBalanceTooHigh;
      } else if (error?.response?.data?.code === "mobileNumberIsNotVerified") {
        message = translations.errorAddingCardPhoneNumber;
      } else {
        if (error?.response?.data?.message) {
          message = error?.response?.data?.message;
        } else if (error?.message) {
          message = error?.message;
        }
      }

      setCardError(message);
      onError(error);
    });
  };

  const cardAdded = wallet?.paymentSource;
  const walletLoading = !wallet;
  useEffect(() => {
    getAddCardUrl();
    getWallet();
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, !hideDeposit && /*#__PURE__*/React.createElement(WalletFastDeposit, {
    onError: onError,
    getWallet: getWallet,
    translations: translations,
    currencySymbol: currencySymbol,
    setTransactionsUpdated: setTransactionsUpdated
  }), /*#__PURE__*/React.createElement(WalletBalance, {
    translations: translations,
    balance: wallet?.balance,
    promoBalance: wallet?.promoBalance,
    currencySymbol: currencySymbol
  }), /*#__PURE__*/React.createElement(WalletHelp, {
    addCardUrl: addCardUrl,
    translations: translations,
    isLoading: !wallet,
    cardAdded: cardAdded,
    phoneVerified: mobileNumberVerified
  }), /*#__PURE__*/React.createElement(WalletButtons, {
    isLoading: !wallet,
    walletLoading: walletLoading,
    isIframe: isIframe,
    cardAdded: cardAdded,
    addCardUrl: addCardUrl,
    addCardError: addCardError,
    dateLocale: dateLocale,
    hideDeposit: hideDeposit,
    hideGamblingReferences: hideGamblingReferences,
    hideTransactions: hideTransactions,
    showFonixDeposit: showFonixDeposit,
    translations: translations,
    transactionsUpdated: transactionsUpdated,
    setTransactionsUpdated: setTransactionsUpdated,
    onError: onError,
    getWallet: getWallet,
    balance: wallet?.balance,
    currencySymbol: currencySymbol,
    isPhoneNumberVerified: mobileNumberVerified,
    toggleActive: toggleActive,
    activeButton: activeButton,
    myId: myId
  }));
};

Wallet.defaultProps = {
  onError: e => console.log(e),
  currencySymbol: "£"
};
Wallet.propTypes = {
  onError: PropTypes.func,
  currencySymbol: PropTypes.string
};
export default Wallet;